import { DEFAULT_EXPORT_COLUMN_OPTIONS } from '../constants';
import { ExportColumn } from '../types';
import resolveColumnAlignment from './resolveColumnAlignment';

interface DatasetItem {
  name?: string;
  label?: string;
  type?: string;
  format?: string;
  formatItem?: string;
  visible?: boolean;
  alignment?: string;
  minWidth?: number;
}

export const resolveExportColumns = (
  items: unknown,
  selectedDefault: boolean,
  _idItem?: string
): ExportColumn[] => {
  const datasetItems: DatasetItem[] = Array.isArray(items)
    ? (items as DatasetItem[])
    : [];

  return datasetItems
    .filter((item) => item.visible !== false)
    .filter((item): item is Required<Pick<DatasetItem, 'name'>> & DatasetItem =>
      Boolean(item.name)
    )
    .map<ExportColumn>((item) => ({
      name: item.name,
      label: item.label ?? item.name,
      selected: selectedDefault,
      isVisible: true,
      formatConfig: {
        name: item.name,
        type: item.type,
        format: item.format,
        formatItem: item.formatItem,
      },
      alignment: resolveColumnAlignment(item.alignment),
      minWidth: item.minWidth,
      // Per-column export tuning starts empty and is preserved across definition reloads.
      exportOptions: DEFAULT_EXPORT_COLUMN_OPTIONS,
    }));
};
